import { ApiError } from '@/api/client';

/**
 * Messages des erreurs métier du parc d'écrans, indexés par le CODE stable de l'API — jamais
 * par son message, qui peut être reformulé côté serveur sans préavis.
 */
const MESSAGES: Record<string, string> = {
  'subscription.screen_allowance_reached':
    "Votre formule n'autorise pas d'écran supplémentaire. Changez de formule depuis « Nos offres » pour en ajouter.",
  'subscription.not_active': "Votre abonnement n'est pas actif : réactivez-le pour déclarer un écran.",
  'establishment.not_found': "Cet établissement n'existe plus. Rechargez la page.",
  'address.invalid_postal_code': 'Le code postal français doit contenir 5 chiffres.',
  'screen.disabled': 'Cet écran est désactivé : réactivez-le avant de l’appairer.',
  'screen.not_found': "Cet écran n'existe plus. Rechargez la page.",
};

export function describeScreenError(error: unknown): string {
  if (error instanceof ApiError) {
    return MESSAGES[error.code] ?? error.message;
  }

  return 'Une erreur inattendue est survenue. Réessayez dans un instant.';
}
